module.exports = __webpack_public_path__ + "static/media/tablet-rugged.148f4b88.svg";